<template>
  <div>
    <h1>User Profile</h1>
    <div v-if="user">
      <h3>{{ user.displayName }}</h3>
      <p>Email: {{ user.email }}</p>
      <!-- <button @click="updateProfile">Update Profile</button> -->
    </div>
    <hr />
    <div v-if="user && user.admin">
      <h3>All Users</h3>
      <ul>
        <li v-for="user in users" :key="user.id">
          {{ user.displayName }}
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
// import { ref, onMounted } from "vue";
import { db, loggedInUser } from "../firebaseConfig";
// import { db } from "firebase";

export default {
  name: "User",
  data() {
    return {
      user: null,
      users: [],
    };
  },
  methods: {
    async updateProfile() {
      // Implement your update profile logic here
    },
  },
  async mounted() {
    this.user = await loggedInUser;
    // Fetch all users if admin
    if (this.user && this.user.admin) {
      const usersSnapshot = await db.collection("users").get();
      this.users = usersSnapshot.docs.map((doc) => doc.data());
    }
  },
};
</script>

<style scoped>
ul {
  list-style-type: none;
  padding: 0;
  margin: 0;
}
</style>
